import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Car, Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { href: "/", label: "Home" },
    { href: "/fleet", label: "Our Fleet" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-sm border-b border-slate-200">
      <div className="container-custom px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group" data-testid="header-logo">
            <div className="w-10 h-10 bg-primary flex items-center justify-center">
              <Car className="w-6 h-6 text-white" />
            </div>
            <div className="hidden sm:block">
              <span className="font-heading font-bold text-lg text-slate-900 tracking-tight">
                Easy Payments
              </span>
              <span className="block text-xs text-slate-500 uppercase tracking-widest">
                Auto Sales
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`font-medium text-sm uppercase tracking-wide transition-colors duration-200 ${
                  isActive(link.href)
                    ? "text-primary"
                    : "text-slate-600 hover:text-slate-900"
                }`}
                data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href="sms:8592703755?body=car%20rental"
              className="flex items-center gap-2"
              data-testid="header-contact-btn"
            >
              <Button className="bg-primary text-white uppercase tracking-wide font-bold btn-brutalist">
                <Phone className="w-4 h-4 mr-2" />
                Text to Book
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-slate-900" />
            ) : (
              <Menu className="w-6 h-6 text-slate-900" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden mobile-menu" data-testid="mobile-menu">
          <div className="flex flex-col items-center justify-center h-full gap-8">
            <button
              className="absolute top-6 right-6"
              onClick={() => setMobileMenuOpen(false)}
            >
              <X className="w-8 h-8 text-white" />
            </button>
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="font-heading text-2xl font-bold text-white uppercase tracking-wide"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="sms:8592703755?body=car%20rental"
              className="mt-8"
              onClick={() => setMobileMenuOpen(false)}
            >
              <Button
                size="lg"
                className="bg-primary text-white uppercase tracking-wide font-bold text-lg px-8 py-6"
              >
                <Phone className="w-5 h-5 mr-2" />
                Text to Book
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
